export default "__VITE_ASSET__Blueed0M__"